import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Td, Text, } from '@chakra-ui/react';
import { ApiDocumentSource } from '@izimi/api';
import { getExtension } from '@izimi/utils';
import { DateCell } from './cells/DateCell';
import { NameCell } from './cells/NameCell';
export const DocumentNameCell = forwardRef(({ document, ...props }, ref) => {
    const isCertified = document.isCertified || document.isNabanDataType;
    return (_jsx(NameCell, { ref: ref, name: document.name, textToHightlight: document.fileNameWithoutExtension, isCertified: isCertified, fileExtension: getExtension(document.name), withFodFinIcon: document.source === ApiDocumentSource.Tuyeau, withNotaryIcon: document.isUploadedByNotary, withCheckmark: document.isCopiedFromInheritedVault, isPending: document.isPending, isSeen: document.isSeen, ...props }));
});
export const EditedDateCell = forwardRef(({ cell, document, ...props }, ref) => (_jsx(DateCell, { id: cell.id, date: document.modificationDate, ref: ref, ...props })));
export const OwnerCell = forwardRef(({ cell, onClick, documentOwnerText }, ref) => {
    return (_jsx(Td, { ref: ref, onClick: onClick, display: { base: 'none', xl: 'table-cell' }, children: _jsx(Text, { variant: 'tableCell', children: documentOwnerText }) }, cell.id));
});
